// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__huWoz","link":"HeaderSimple_link__y3gyO"};